(() => {
  const initialized = new WeakSet();
  const init = () => document.querySelectorAll('product-info').forEach(info => {
    if (initialized.has(info)) return;
    const size = info.querySelector('[data-an-size-option]');
    if (!size) return;
    initialized.add(info);
    const selectedSize = size.querySelector('input:checked');
    if (selectedSize) info.dataset.anSizeChosen = selectedSize.value;
    let hasSizeInteraction = false;
    const sync = () => {
      const field = info.querySelector('[data-an-size-option]');
      if (!field) return;
      const chosen = info.dataset.anSizeChosen;
      const mainButton = info.querySelector('product-form button[name="add"]');
      const label = mainButton?.querySelector('span');
      const sizeSelected = field.querySelector('input:checked,select option:checked:not([value=""])');
      info.querySelectorAll('.an-native-colors').forEach(colorField => {
        const colorLabel = colorField.querySelector('[data-an-color-label]');
        const colorValue = colorField.querySelector('input:checked')?.value;
        if (colorLabel && colorValue && colorLabel.textContent !== colorValue) colorLabel.textContent = colorValue;
      });
      const buttonText = mainButton?.dataset.anAddLabel;
      if (label && !mainButton.disabled && buttonText && label.textContent.trim() !== buttonText) {
        label.textContent = buttonText;
      }
      const decision = info.querySelector('[data-an-purchase-decision]');
      const selectionSummary = decision?.querySelector('[data-an-selection-summary]');
      if (selectionSummary) {
        const picker = info.querySelector('variant-selects');
        const selectedOptions = picker ? [...picker.querySelectorAll('fieldset')].map(option => option.querySelector('input:checked')?.value).concat([...picker.querySelectorAll('select')].map(select => select.value)).filter(Boolean) : [];
        const selectionText = sizeSelected ? decision.dataset.selected.replace('__SELECTION__', selectedOptions.join(' · ')) : decision.dataset.empty;
        if (selectionSummary.textContent !== selectionText) selectionSummary.textContent = selectionText;
      }
      if (chosen) info.querySelector('[data-an-size-prompt]')?.remove();
      const guide = Array.from(info.querySelectorAll('a,button,[role="button"]')).find(el => !el.classList.contains('an-inline-size-guide') && /guía de tallas/i.test(el.textContent));
      const sizeIds = new Set(Array.from(field.querySelectorAll('input[data-option-value-id]'), el => el.dataset.optionValueId));
      const appSize = Array.from(info.querySelectorAll('.swatch-view [role="radio"]')).find(el => sizeIds.has(el.getAttribute('option-value-id')));
      const legend = appSize?.closest('fieldset')?.querySelector('legend') || field.querySelector('legend');
      if (legend && appSize) legend.classList.add('an-size-guide-legend');
      const nativeGuide = info.querySelector('[data-an-standard-guide] [data-an-open-size-guide], [data-an-supplier-guide] > [data-an-open-size-guide], .an-inline-native-guide');
      if (nativeGuide && legend) {
        nativeGuide.classList.remove('an-source-size-guide');
        nativeGuide.classList.add('an-inline-native-guide');
        if (!legend.contains(nativeGuide)) legend.append(nativeGuide);
        info.querySelector('.an-inline-size-guide')?.remove();
      }
      const existingShortcut = info.querySelector('.an-inline-size-guide');
      if (existingShortcut && legend && !legend.contains(existingShortcut)) legend.append(existingShortcut);
      if (!nativeGuide && guide && legend && !legend.querySelector('.an-inline-size-guide')) {
        const shortcut = document.createElement('button');
        shortcut.type = 'button';
        shortcut.className = 'an-inline-size-guide link';
        shortcut.textContent = guide.textContent.trim();
        shortcut.addEventListener('click', () => guide.click());
        guide.classList.add('an-source-size-guide');
        legend.append(shortcut);
      }
    };
    const choose = () => {
      const field = info.querySelector('[data-an-size-option]');
      if (!field) return;
      const sizeIds = new Set(Array.from(field.querySelectorAll('input[data-option-value-id]'), input => input.dataset.optionValueId));
      const appSize = Array.from(info.querySelectorAll('.swatch-view [role="radio"]')).find(radio => sizeIds.has(radio.getAttribute('option-value-id')) && radio.getClientRects().length);
      const target = appSize?.closest('fieldset') || field;
      if (!info.querySelector('[data-an-size-prompt]')) {
        const prompt = document.createElement('p');
        prompt.dataset.anSizePrompt = '';
        prompt.setAttribute('role', 'alert');
        prompt.textContent = field.dataset.anChooseLabel;
        target.after(prompt);
      }
      const focusTarget = target.querySelector('[role="radio"][aria-checked="true"]') || target.querySelector('[role="radio"]:not([aria-disabled="true"])') || field.querySelector('input:not([disabled]):not(.disabled)');
      target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'center'});
      focusTarget?.focus({preventScroll:true});
    };
    info.addEventListener('an:choose-size', event => { event.preventDefault(); choose(); });
    info.addEventListener('change', event => {
      if (event.target.matches('[data-an-size-option] input') && hasSizeInteraction) {
        info.dataset.anSizeChosen = event.target.value;
        sync();
      }
    }, true);
    const registerSizeInteraction = event => {
      if (!event.isTrusted) return;
      const field = info.querySelector('[data-an-size-option]');
      const radio = event.target.closest('.swatch-view [role="radio"]');
      const optionId = radio?.getAttribute('option-value-id');
      const isAppSize = optionId && Array.from(field?.querySelectorAll('input[data-option-value-id]') || []).some(input => input.dataset.optionValueId === optionId);
      if (field?.contains(event.target) || isAppSize) hasSizeInteraction = true;
    };
    info.addEventListener('pointerdown', registerSizeInteraction, true);
    info.addEventListener('keydown', registerSizeInteraction, true);
    info.addEventListener('click', event => {
      if (event.isTrusted) {
        const field = info.querySelector('[data-an-size-option]');
        const label = event.target.closest('label');
        const nativeInput = event.target.matches('input') ? event.target : (label?.control || label?.querySelector('input'));
        if (nativeInput && field?.contains(nativeInput) && !nativeInput.disabled && !nativeInput.classList.contains('disabled')) {
          hasSizeInteraction = true;
          info.dataset.anSizeChosen = nativeInput.value;
          sync();
        }
      }
      if (event.isTrusted && hasSizeInteraction) {
        const radio = event.target.closest('.swatch-view [role="radio"]');
        const field = info.querySelector('[data-an-size-option]');
        if (radio && field && radio.getAttribute('aria-disabled') !== 'true') {
          const optionId = radio.getAttribute('option-value-id');
          const input = Array.from(field.querySelectorAll('input[data-option-value-id]')).find(input => input.dataset.optionValueId === optionId);
          if (input) {
            info.dataset.anSizeChosen = input.value;
            sync();
          }
        }
      }
    }, true);
    new MutationObserver(sync).observe(info,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','data-an-size-chosen']});
    sync();
  });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-an-open-size-guide]');
    if (!trigger) return;
    const supplierGuide = document.querySelector('[data-an-supplier-guide]');
    if (supplierGuide) {
      event.preventDefault();
      const dialog = supplierGuide.querySelector('[data-an-size-dialog]');
      if (!dialog || dialog.open) return;
      dialog.anOpenedBy = trigger;
      dialog.showModal();
      dialog.querySelector('h2').focus({preventScroll:true});
      return;
    }
    const guide = document.querySelector('product-info .an-inline-size-guide');
    if (guide) {
      event.preventDefault();
      guide.click();
    }
  });
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-an-close-size-guide]');
    if (close) close.closest('dialog')?.close();
    if (event.target.matches('[data-an-size-dialog]')) {
      const dialog = event.target;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }
  });
  document.addEventListener('close', event => {
    if (event.target.matches('[data-an-size-dialog]') && event.target.anOpenedBy?.isConnected) event.target.anOpenedBy.focus({preventScroll:true});
  }, true);
  const requireSize = event => {
    const target = event.target;
    const add = event.type === 'submit' ? target.querySelector('button[name="add"]') : target.closest('button[name="add"]');
    const info = add?.closest('product-info');
    const field = info?.querySelector('[data-an-size-option]');
    if (!field || field.querySelector('input:checked,select option:checked:not([value=""])')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    info.dispatchEvent(new CustomEvent('an:choose-size', {bubbles:true}));
  };
  window.addEventListener('click', requireSize, true);
  window.addEventListener('submit', requireSize, true);
  init();
  document.addEventListener('shopify:section:load',init);
  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('product-info') || node.querySelector('product-info'))))) init();
  }).observe(document.querySelector('main') || document.body,{childList:true,subtree:true});
})();




